import { IconProps } from "@amzn/awsui-components-console";

import { UpdateCacheAction } from "../cached-messages/types";

export const CACHE_ACTION_ICONS: Record<UpdateCacheAction, IconProps.Name> = {
  [UpdateCacheAction.CACHE]: "edit",
  [UpdateCacheAction.UNCACHE]: "delete-marker",
  // TODO: figure out in case we actually do clear
  [UpdateCacheAction.CLEAR]: "delete-marker",
};
